<template lang="pug">
.the-nav
  b-navbar(:class="$style.nav"
    type="is-whiter"
    transparent
    fixed-top
    close-on-click)
    template(slot="brand")
      b-navbar-item(to="/"
        tag="router-link")
        img(:src="brand"
          alt="首頁")
    template(slot="start")
      b-navbar-item(:to="{ name: 'news' }"
        tag="router-link") 最新消息
      b-navbar-item(:to="{ name: 'activity' }"
        tag="router-link") 活動花絮
      b-navbar-item(:to="{ name: 'calendar' }"
        tag="router-link") 年度計畫
      b-navbar-item(:to="{ name: 'shops' }"
        tag="router-link") 屏東人ㄟ店
      b-navbar-item
        b-dropdown(aria-role="menu"
          hoverable)
          div(slot="trigger")
            span 關於同鄉會
            b-icon(pack="fas"
              icon="angle-down"
              size="is-small")
          b-dropdown-item(aria-role="menuitem"
            has-link)
            router-link(:to="{ name: 'intro-purpose' }") 宗旨
            router-link(:to="{ name: 'intro-rule' }") 章程
            router-link(:to="{ name: 'intro-pastchairmans' }") 歷屆理事長
            router-link(:to="{ name: 'intro-staffs' }") 18屆會務人員名冊
            router-link(:to="{ name: 'intro-advisors' }") 顧問團
      b-navbar-item
        b-dropdown(aria-role="menu"
          hoverable)
          div(slot="trigger")
            span 歷屆理事長的話
            b-icon(pack="fas"
              icon="angle-down"
              size="is-small")
          b-dropdown-item(aria-role="menuitem"
            has-link)
            router-link(:to="{ name: 'talks-18-1' }") 18屆-廖憲武
            router-link(:to="{ name: 'talks-17-1' }") 17屆第1次-廖憲武
            router-link(:to="{ name: 'talks-16-2' }") 16屆第2次-葉進華
            router-link(:to="{ name: 'talks-16-1' }") 16屆第1次-葉進華
            router-link(:to="{ name: 'talks-15-2' }") 15屆第2次-葉進華
            router-link(:to="{ name: 'talks-15-1' }") 15屆第1次-葉進華
      b-navbar-item
        b-dropdown(aria-role="menu"
          hoverable)
          div(slot="trigger")
            span 相關文件
            b-icon(pack="fas"
              icon="angle-down"
              size="is-small")
          b-dropdown-item(aria-role="menuitem"
            has-link)
            //router-link(:to="{ name: 'official_docs' }") 公文
            router-link(:to="{ name: 'applications' }") 辦法申請
      //b-navbar-item 屏東人ㄟ店
    template(slot="end")
      b-navbar-item(href="https://typt.org/backstage/") 幹部登入
</template>

<script>
import brand from "@/assets/images/brand.png";

export default {
  name: "TheNav",
  data() {
    return {
      brand,
    };
  },
};
</script>

<style module lang="sass">
.nav
  border-bottom: .5px solid lighten($dark, 60%)
</style>
